import { createIcon } from '@chakra-ui/react';

export const FilterWhiteIcon = createIcon({
  displayName: 'FilterWhiteIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
          d="M14.667 4.33334H10.667"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.99967 4.33334H1.33301"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66634 6.66667C7.95501 6.66667 8.99967 5.622 8.99967 4.33333C8.99967 3.04467 7.95501 2 6.66634 2C5.37768 2 4.33301 3.04467 4.33301 4.33333C4.33301 5.622 5.37768 6.66667 6.66634 6.66667Z"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6667 11.6667H12"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33301 11.6667H1.33301"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33333 14C10.622 14 11.6667 12.9553 11.6667 11.6667C11.6667 10.378 10.622 9.33334 9.33333 9.33334C8.04467 9.33334 7 10.378 7 11.6667C7 12.9553 8.04467 14 9.33333 14Z"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
